/**
 * FOMO.com popups — swap stale product thumbs, title-case product names,
 * and throttle how often they appear (random + less frequent).
 *
 * Important: never mutate the DOM from a MutationObserver without a guard,
 * or class toggles will recurse and freeze the page.
 */
(function () {
  var mapEl = document.getElementById("ib-fomo-product-images");
  if (!mapEl) return;

  var imageMap = {};
  try {
    imageMap = JSON.parse(mapEl.textContent || "{}");
  } catch (e) {
    return;
  }

  // Fewer, more random appearances than FOMO's default cadence
  var FIRST_MIN_MS = 45000;
  var FIRST_MAX_MS = 90000;
  var GAP_MIN_MS = 90000;
  var GAP_MAX_MS = 240000;
  var MAX_PER_PAGE = 2;
  var SHOW_MS = 7000;

  function randBetween(min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  var shownCount = 0;
  var nextAllowedAt = Date.now() + randBetween(FIRST_MIN_MS, FIRST_MAX_MS);
  var releaseTimer = null;
  var allowing = false;
  var applying = false;
  var scanQueued = false;

  function handleFromUrl(url) {
    if (!url) return "";
    try {
      var path = new URL(url, window.location.origin).pathname;
      var m = path.match(/\/products\/([^/?#]+)/i);
      return m ? decodeURIComponent(m[1]).toLowerCase() : "";
    } catch (e) {
      return "";
    }
  }

  function resolveImage(handle) {
    if (!handle) return "";
    return imageMap[handle] || imageMap[handle.replace(/-/g, "")] || "";
  }

  /** "BALANCE Complex" → "Balance Complex" */
  function titleCaseWords(str) {
    return String(str || "")
      .toLowerCase()
      .replace(/(^|[\s\-_/])([a-z])/g, function (_, boundary, letter) {
        return boundary + letter.toUpperCase();
      });
  }

  function setSuppressed(el, suppressed) {
    if (!el) return;
    var wantSuppressed = !!suppressed;
    var isSuppressed = el.classList.contains("ib-fomo-suppressed");
    var isAllowed = el.classList.contains("ib-fomo-allowed");
    if (wantSuppressed && isSuppressed && !isAllowed) return;
    if (!wantSuppressed && isAllowed && !isSuppressed) return;

    applying = true;
    try {
      if (wantSuppressed) {
        el.classList.remove("ib-fomo-allowed");
        el.classList.add("ib-fomo-suppressed");
      } else {
        el.classList.remove("ib-fomo-suppressed");
        el.classList.add("ib-fomo-allowed");
      }
    } finally {
      applying = false;
    }
  }

  function scheduleNextGap() {
    nextAllowedAt = Date.now() + randBetween(GAP_MIN_MS, GAP_MAX_MS);
  }

  function endAllowance(el) {
    allowing = false;
    setSuppressed(el, true);
    scheduleNextGap();
  }

  function upgradeNotification(root) {
    if (!root) return;
    var img = root.querySelector("img.fomo-notification-image");
    var content = root.querySelector(".fomo-notification-content");
    var link = content && content.querySelector("a[href*='/products/']");

    if (link) {
      var label = (link.textContent || "").trim();
      var titled = titleCaseWords(label);
      if (label && titled && label !== titled) {
        applying = true;
        try {
          link.textContent = titled;
        } finally {
          applying = false;
        }
      }
    }

    if (!img || !link) return;

    var handle = handleFromUrl(link.getAttribute("href"));
    var next = resolveImage(handle);
    if (!next) return;

    if (next.indexOf("//") === 0) next = window.location.protocol + next;

    applying = true;
    try {
      if (img.getAttribute("src") !== next) img.setAttribute("src", next);
      if (img.hasAttribute("srcset")) img.removeAttribute("srcset");
    } finally {
      applying = false;
    }
  }

  function fomoWantsVisible(el) {
    if (!el || !el.isConnected) return false;
    if (el.hasAttribute("hidden")) return false;
    // Ignore our own suppress class when reading FOMO's inline styles
    var style = el.style;
    if (style && style.display === "none") return false;
    // FOMO typically sets display/opacity via style or animates in
    if (style && (style.opacity === "0" || style.visibility === "hidden")) return false;
    // Presence of content is enough — FOMO injects copy when it fires
    return !!el.querySelector(".fomo-notification-content");
  }

  function gate(el) {
    upgradeNotification(el);

    if (allowing && el.classList.contains("ib-fomo-allowed")) return;

    var now = Date.now();
    if (!fomoWantsVisible(el) || shownCount >= MAX_PER_PAGE || now < nextAllowedAt) {
      setSuppressed(el, true);
      return;
    }

    allowing = true;
    shownCount += 1;
    setSuppressed(el, false);
    if (releaseTimer) clearTimeout(releaseTimer);
    releaseTimer = setTimeout(function () {
      endAllowance(el);
    }, SHOW_MS);
  }

  function scan() {
    if (applying) return;
    var seen = [];
    var main = document.getElementById("someone-purchased");
    if (main) seen.push(main);
    document.querySelectorAll(".fomo-notification").forEach(function (n) {
      if (seen.indexOf(n) === -1) seen.push(n);
    });
    seen.forEach(gate);
  }

  function queueScan() {
    if (applying || scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  scan();

  var obs = new MutationObserver(function () {
    if (applying) return;
    queueScan();
  });
  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    // Do not watch "class" — our suppress/allow toggles would re-enter forever
    attributeFilter: ["src", "href", "style", "hidden"],
  });
})();
